<template lang="pug">
    div
        // Direcions
        v-dialog(transition="dialog-bottom-transition" :max-width='!isMobile ? "600px" : "100%"' v-model='dialogUserLocation' :fullscreen="isMobile" v-if="dialogUserLocation")
            user-locations(:currentPosition="currentPosition" @closeModalUserLocation="dialogUserLocation=false" :max-width="isMobile ? '' : '600px'")
        // Map
        v-dialog(v-if="dialogMap" transition="dialog-bottom-transition" :max-width='!isMobile ? "800px" : "100%"' v-model='dialogMap' :fullscreen="isMobile")
            Map(:direction="currentItem" @close="dialogMap = false")
        v-col(cols="12").text-right
            v-btn(small color="primary" @click="dialogUserLocation = true") Agregar Dirección
        v-col(cols="12")
            v-subheader(v-if="!actualLocation") Dirección principal
            v-subheader(v-else) Posición Actual
            v-list(two-line="" subheader="")
                v-list-item(v-if="!actualLocation" @click="openMap(defaultLocationVar)")
                    v-list-item-avatar
                        v-icon(class="green white--text" v-text="'mdi-home'")
                    v-list-item-content
                        v-list-item-title(v-text="defaultLocationVar.direction")
                        v-list-item-subtitle(v-text="'Dirección principal'")
                v-list-item(v-else)
                    v-list-item-avatar
                        v-icon(class="green white--text" v-text="'mdi-map-marker'")
                    v-list-item-content
                        v-list-item-title(v-text="defaultLocationVar.direction")
                        v-list-item-subtitle(v-text="'Dirección actual'")
        v-col(cols="12" v-if="locationsLst.length > 0")
            v-list(two-line subheader)
                v-subheader Direcciones
                v-list-item(v-for="directions in locationsLst" @click="openMap(directions.data)")
                    v-list-item-avatar
                        v-icon(class="primary white--text" v-text="'mdi-map-marker'")
                    v-list-item-content
                        v-list-item-title(v-text="directions.data.title")
                        v-list-item-subtitle(v-text="directions.data.direction")
</template>

<script>
  import * as vars from '@/vars.json'
  const geocoding = require('reverse-geocoding-google')
  export default {
    components: {
      UserLocations: () => import('@/views/marketplace/components/UserLocations'),
      Map: () => import('@/views/marketplace/component/profile/Map'),
    },
    data () {
      return {
        currentPosition: '',
        dialogUserLocation: false,
        dialogMap: false,
        currentItem: '',
      }
    },
    computed: {
      isMobile () {
        return window.innerWidth < 1024
      },
      defaultLocationVar () {
        if (this.$store.state.users.profile.defaultlocation) {
          return this.$store.state.users.profile.defaultlocation
        } else {
          return {
            direction: this.currentPosition,
          }
        }
      },
      actualLocation () {
        if (this.$store.state.users.profile.defaultlocation) {
          return false
        } else {
          return true
        }
      },
      locationsLst () {
        const profile = this.$store.state.users.profile
        const arrLocations = profile.locations
        let arr = []
        if (arrLocations) {
          arr = Object.keys(arrLocations).map(location => {
            return { id: location, data: arrLocations[location] }
          })
        }
        return arr
      },
    },
    created () {
      this.geolocate()
    },
    methods: {
      geolocate () {
        const vm = this
        navigator.geolocation.getCurrentPosition(position => {
          vm.getDirecction(position.coords.latitude, position.coords.longitude)
        })
      },
      getDirecction (latitude, longitude) {
        const config = {
          latitude: latitude,
          longitude: longitude,
          key: vars.googleKey,
        }
        geocoding.location(config, (err, data) => {
          if (err) {
            // console.log(err)
          } else {
            this.currentPosition = data.results[0].formatted_address
          }
        })
      },
      openMap (position) {
        // console.log(position)
        const vm = this
        if (position.location) {
          vm.currentItem = {
            ...position.location,
          }
        }
        vm.dialogMap = true
      },
    },
  }
</script>
